module.exports = __webpack_public_path__ + "6771072149229c58ad0dff4cba91dc91.svg";